<template>
  <div class="grid">
    <Flickity
      class="flickity"
      ref="flickity"
      v-on:init="flickityInit"
      :options="flickityOptions"
    >
      <Feature
        v-for="feature in featured"
        type="event"
        :page="feature"
        :key="feature.url"
      ></Feature>
    </Flickity>
    <div class="calendars" :style="{ gridTemplateColumns: 'repeat(' + monthsVisible + ', 1fr)' }">
      <button
        class="icon icon-button-arrow left"
        @click="calendarPaginate(-1)"
        v-if="hasPrev"
      ></button>
      <button
        class="icon icon-button-arrow right"
        @click="calendarPaginate(1)"
        v-if="hasNext"
      ></button>
      <Calendar
        v-for="(calendar, i) in calendars"
        :active="day"
        :month="calendar"
        :key="i"
      ></Calendar>
    </div>
    <div class="grid-auto-lg pill-hover">
      <ArchiveThumb
        v-for="item in qpages"
        :page="item"
        :key="item.url"
        :add-to-calendar="true"
      ></ArchiveThumb>
    </div>
    <BoxDonate></BoxDonate>
  </div>
</template>

<script>
import ArchiveThumb from '@/components/ArchiveThumb'
import BoxDonate from '@/components/BoxDonate'
import Calendar from '@/components/Calendar'
import Feature from '@/components/Feature'
import { mixin } from '@/lib/content-state'
import Flickity from 'vue-flickity'
import delve from 'dlv'

export default {
  name: 'Events',
  components: { ArchiveThumb, Flickity, Calendar, Feature, BoxDonate },
  mixins: [ mixin ],
  data () {
    return {
      flickityOptions: {
        autoPlay: true,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        cellAlign: 'left',
        lazyLoad: 4
      },
      monthsVisible: 4,
    }
  },
  created () {
    window.addEventListener('resize', this.resize, false)
    if (!this.monthActiveIndex) this.monthActiveIndex = this.page.currentIndex
    this.resize()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resize, false)
  },
  computed: {
    day () {
      const today = new Date()
      let dd = today.getDate()
      if (dd < 10) dd = '0' + dd
      let mm = today.getMonth() + 1
      if (mm < 10) mm = '0' + mm
      return this.$route.query.day
        ? this.$route.query.day
        : [today.getFullYear(), mm, dd].join('-')
    },
    monthActiveIndex: {
      get () {
        return this.$store.state.ui.monthActiveIndex
      },
      set (value) {
        this.$store.dispatch('updateUi', { monthActiveIndex: value })
      }
    },
    featured () {
      return this.$store.getters.getPages(delve(this, 'page.featured'))
    },
    calendars () {
      const calendars = delve(this, 'page.calendars')
      if (calendars) {
        const output = new Array(this.monthsVisible)
          .fill('')
          .map((data, i) => this.page.calendars[this.monthActiveIndex + i])
          .filter(p => p)
        return output
      } else return []
    },
    hasNext () {
      if (!this.page.calendars) return false
      return this.monthActiveIndex < this.page.calendars.length  - this.monthsVisible
    },
    hasPrev () {
      if (!this.page.calendars) return false
      return this.monthActiveIndex > 1
    }
  },
  methods: {
    resize () {
      this.monthsVisible = Math.floor(window.innerWidth / 300)
    },
    calendarPaginate (amount) {
      const nextIndex = this.monthActiveIndex + amount
      if (nextIndex > 0 && nextIndex <= this.page.calendars.length - this.monthsVisible) {
        this.monthActiveIndex = nextIndex
      }
    },
    flickityInit () {
      this.$refs.flickity.on('dragStart', () => {
        this.$refs.flickity.$el.style.pointerEvents = 'none'
      })
      this.$refs.flickity.on('dragEnd', () => {
        this.$refs.flickity.$el.style.pointerEvents = 'auto'
      })
    }
  }
}
</script>

<style scoped>
.calendars {
  display: grid;
  grid-column-gap: 2rem;
  grid-column: 1 / -1;
  position: relative;
}

.calendars button {
  margin: 1rem;
  position: absolute;
  top: 0;
  z-index: 2;
}

.calendars button.right {
  right: 0;
}

.Calendar {
  grid-column: 1fr;
}

.flickity {
  grid-column: 1 / -1;
  margin-left: -2rem;
  margin-right: -2rem;
}

.Feature-Container { 
  padding-left: 2rem; 
  padding-right: 2px;
  width: 40vw; 
}

.grid-auto-lg {
  margin-top: 1rem;
}

@media (max-width: 1280px) {
  .Feature-Container { width: 46vw; }
}

@media (max-width: 1000px) {
  .Feature-Container { width: 30rem; }
}
</style>